module.exports = __webpack_public_path__ + "static/media/viasat-jaakiekko.cc5d7cdc.png";